export enum VariantsEnum {
  SEARCH = 'search',
  NOITEMS = 'noItems',
  RELAXED_ROBOT = 'relaxed',
  WONDERING = 'wondering'
}

export type FallbackVariantsType = VariantsEnum.SEARCH | VariantsEnum.NOITEMS | VariantsEnum.RELAXED_ROBOT | VariantsEnum.WONDERING;
